<div class="min-h-screen bg-white">
  <app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

  <!-- Hero Banner -->
  <app-hero-banner></app-hero-banner>

  <!-- Top Offers Section -->
  <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <h2 class="text-xl font-bold text-gray-900 mb-4">Top Offers</h2>
    <div class="relative">
      <button *ngIf="showLeft" (click)="scrollOffers('left')"
        class="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors">
        <lucide-icon name="chevron-left" class="w-5 h-5 text-gray-600"></lucide-icon>
      </button>
      <div #offersContainer class="flex space-x-4 overflow-x-auto scrollbar-hide pb-2">
        <div *ngFor="let offer of offers" [class]="getOfferClasses(offer)"
          class="flex-shrink-0 w-32 h-28 rounded-xl flex flex-col items-center justify-center p-3 cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
          <p [class]="offer.textColor" class="text-sm font-bold text-center leading-tight">{{ offer.title }}</p>
          <p *ngIf="offer.subtitle" [class]="offer.textColor" class="text-sm font-bold text-center leading-tight">{{
            offer.subtitle }}</p>
          <p *ngIf="offer.price" [class]="offer.textColor" class="text-xl font-black mt-1">{{ offer.price }}</p>
          <p *ngIf="offer.extra" [class]="offer.textColor" class="text-xs mt-1">{{ offer.extra }}</p>
        </div>
      </div>
      <button *ngIf="showRight" (click)="scrollOffers('right')"
        class="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors">
        <lucide-icon name="chevron-right" class="w-5 h-5 text-gray-600"></lucide-icon>
      </button>
    </div>
  </section>

  <!-- Divider -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <hr class="border-gray-200" />
  </div>

  <!-- Restaurants Section -->
  <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <h2 class="text-2xl font-bold text-gray-900 mb-6">Our Restaurants</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <app-restaurant-card *ngFor="let restaurant of restaurants" [restaurant]="restaurant"
        [disabled]="storeLatitudeMap == null || storeLongitudeMap == null" [aggregatorSetup]="aggregatorSetup"></app-restaurant-card>
    </div>
  </section>

  <!-- App Download Banner -->
  <!-- <section class="bg-gradient-to-r from-orange-500 to-red-500 py-12 my-8">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col md:flex-row items-center justify-between">
            <div class="text-white text-center md:text-left mb-6 md:mb-0">
              <h3 class="text-3xl font-bold mb-2">Download the Capital Food App</h3>
              <p class="text-white/90">Get exclusive deals and order your favorite food on the go!</p>
            </div>
            <div class="flex space-x-4">
              <button class="bg-white text-orange-500 hover:bg-gray-100 rounded-full px-6 py-3 font-semibold">
                App Store
              </button>
              <button class="bg-white text-orange-500 hover:bg-gray-100 rounded-full px-6 py-3 font-semibold">
                Play Store
              </button>
            </div>
          </div>
        </div>
      </section> -->

  <app-footer></app-footer>
</div>